import { eventGA } from './ga';
//
function openExternalURL(gaName, gaMessage, link) {
    eventGA(gaName, gaMessage);
    window.open(link);
}
export { openExternalURL }